"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JumbotronHr;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("hr", {
  className: "m-y-2"
});
function JumbotronHr() {
  return _ref;
}